'use strict';
const angular = require('angular');

export class ContactEditComponent {
  /*@ngInject*/
  constructor(SettingsService, ContactService) {
    this.emails = [];
    this.SettingsService = SettingsService;
    this.ContactService = ContactService;

    this.customSchema = {
      "type": "object",
      "properties": {
        "eVotingConsent": {
          "type": "boolean",
          "title": "Online Voting Consent"
        },
        "eContactConsent": {
          "type": "boolean",
          "title": "Electronic Communication Consent"
        }
      }
    };
    this.customForm = ["*"];
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.contactId) {
      this.ContactService.get({id: this.config.contactId}, data => {
        this.model = data;
        if (!this.model.address)
          this.model.address = {};

        this.customFields = this.model.customFields || {};

        this.SettingsService.getByName({name: 'config.app'}, appSettings => {
          this.mailTypes = appSettings.data.mailTypes;

          if (!this.model.email || !this.model.email.length)
            this.addEmail();
        });
      }, err => {
        console.log('Could not load contact data from server');
      })
    } else {
      this.customFields = {};
    }
  }

  updatePrimaryEmail(idx) {
    angular.forEach(this.model.email, (email, index) => {
      email.isPrimary = (idx == index);
    });
  }

  addEmail() {
    this.model.email.push({
      type: this.mailTypes[0] || '-',
      address: '',
      isPrimary: !this.model.email.length
    })
  }

  removeEmail(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.model.email[idx].isPrimary;

    // remove the phone
    this.model.email.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.model.email.length > 0) {
      this.model.email[0].isPrimary = true;
    }
  }

  ok() {
    this.model.customFields = this.customFields || {};

    this.close({$value: this.model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.contactEditModal', [])
  .component('contactEditModal', {
    template: require('./contact-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ContactEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/contact-edit/contact-edit.component.js